export default "__VITE_PUBLIC_ASSET__4b9aee06__"